import { lazy } from 'react';
import { Route } from 'react-router-dom';

const InviteLandingPage = lazy(() =>
  import('./pages/InviteLandingPage').then(m => ({ default: m.InviteLandingPage }))
);

/** Invite deep-link landing — mounted at the TOP level (outside RequireAuth):
 *  the page itself branches on auth status, redirecting signed-out visitors
 *  to the pre-scoped register page with the token preserved. */
export const inviteRoutes = <Route path="/invite" element={<InviteLandingPage />} />;
